<!--
V 0.6.0 - 2026-06-01
     - Added Fleet Dashboard link, and moved to the top of menu

V 0.5.0 - 2026-03-17
     - Added note about keep-alive

  V 0.4.0 - 2025-08-05
      - Removed the: this.$router.go(-1), and added rouiting so that I could go back
        to calendar and be in the place form which I navigated.

  V 0.3.0 - 2024-09-17
      - Added Mole link and updated vehicle selects

  V 0.2.0 - 2024-07-10
     - Added Day Tripper link

  V 0.1.4 - 2023-03-22
     - Updated links to vehicle-select

  V 0.1.3 - 2023-03-20
     - removed the icon.

  V 0.1.1 - 2023-03-08
     -  Removed Alarms and commented out code

  V 0.1.0 - 2023-02-28
     - movoed from route of Pages director
     - removed the footer with versino and date because it was taking screen
       space

-->
<template>
  <v-app>
    <!--
          ____________________________________________________ Sidbar
    -->
    <v-navigation-drawer v-model="drawer" dense app>
      <v-list dense>
        <v-list-item v-if="!simpleView"
                     to="/map-all"
                     link>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/fleet-dashboard" link>
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Fleet Dashboard </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!simpleView"
                     to="/vehicle-select/map-follow/38/Track & Recover"
                     link>
          <v-list-item-action>
            <v-icon>fa-solid fa-location-crosshairs</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Track & Recover</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/unit-select/mole-select/-38/Recover" link>
          <v-list-item-action>
            <v-icon>fas fa-car-side</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Recover</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="simpleView"
                     to="/vehicle-select/car-battery/0/Battery" link>
          <v-list-item-action>
            <v-icon>fas fa-battery-half</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Battery Graph </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Trips Sub Menu -->
        <v-list-group v-if="!simpleView"
                      no-action
                      prepend-icon="fas fa-route"
                      :value="false">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Trips</v-list-item-title>
            </v-list-item-content>
          </template>

        <v-list-item  to="/vehicle-select/day-navigator/38/Trip Navigator"  link>
          <v-list-item-action>
            <v-icon>mdi-road-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Navigator </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item   to="/vehicle-select/calendar-trips-select/38/Trip Calendar"
                     link>
          <v-list-item-action>
            <v-icon>mdi-calendar-expand-horizontal</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Calendar </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item   to="/vehicle-select/trip-list/38/Trip List" link>
          <v-list-item-action>
            <v-icon>fas fa-timeline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>List </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

          <v-list-item to="/vehicle-select/day-select-timeline/38/Timeline" link>
            <v-list-item-icon>
              <v-icon>mdi-timeline-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Graphic </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- End Trips Sub Menu -->

        <!-- Reports Sub Menu -->
        <v-list-group v-if="!simpleView"
                      no-action
                      prepend-icon="mdi-chart-line"
                      :value="false">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Reports</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/vehicle-select/trip-list-speed/38/Vehicle Speed" link>
            <v-list-item-action>
              <v-icon>fa-gauge-high</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Speed Graphs </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/vehicle-select/car-battery/0/Battery" link>
            <v-list-item-action>
              <v-icon>fas fa-battery-half</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Battery Graph </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/vehicle-select/obd-trip-select/38/OBD Data" link>
            <v-list-item-action>
              <v-icon>fas fa-wrench</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>OBD Graph </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-on:click="fullScreen()" v-if="fullScreenEnabled">
          <v-list-item-action>
            <v-icon>fa fa-compress</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Normal Screen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-on:click="fullScreen()" v-else>
          <v-list-item-action>
            <v-icon>fa fa-arrows-alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Full Screen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/about" link>
          <v-list-item-action>
            <v-icon>mdi mdi-information-outline</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout . . .</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-img :src="`${$staticBaseUrl}/img/powered_by_head_shed_login.png`"
             width="256px"
             dark>
        <v-row class="fill-height">
          <v-card-title>
            <v-btn dark icon>
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-spacer></v-spacer>
          </v-card-title>

          <v-spacer></v-spacer>
        </v-row>
      </v-img>

      <v-flex class="text-xs-center font-weight-thin">
        {{ $year }}. All rights reserved. V
        {{ $version }}
      </v-flex>
    </v-navigation-drawer>

    <!--
          ____________________________________________________ End Sidbar _______________________________________________

    -->

     <!--
    -----------------------------------------------------------------------------------------------------------------------------------------

                                                                 Top Menu:

    -----------------------------------------------------------------------------------------------------------------------------------------
    -->

    <v-app-bar app color="blue" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Raptor Mobile &nbsp; &nbsp; </v-toolbar-title>
      <v-btn class="ml-4" icon outlined @click="navigateBack()">
        <v-icon>mdi-arrow-left-bold</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item to="/logout" dense>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-title> Logout ( {{ userName }} ) </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-main>
<!--
    (2026-03-17 ) Note:
              I was not aware of the keep-alive component when I first built this,
              it may be an idea in futre to use this to keep state on pages like
              Vehicle select, or trips, or anything that should allow user to navigate back

              <keep-alive include="Home,Profile,ProductDetail" exclude="Admin*" max="10">
                <router-view />
              </keep-alive>
 -->
        <router-view v-on:update-cart="updateCart"></router-view>
    </v-main>
  </v-app>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */

export default {
  data () {
    return {
      simpleView: this.$store.state.simpleView,

      // try implement back to calling date etc
      dayDate: '',
      previousPage: '',
      UnitID: '',
      VehicleReg: '',
      currentViewName: '',

      ///

      drawer: null,

      version: this.$version,

      userName: this.$store.state.userName,

      fullScreenEnabled: false
    }
  },

  created () {
    this.currentViewName = this.$route.name || this.$route.path
  },

  watch: {
    $route (to, from) {
      this.currentViewName = to.name || to.path // Use route name if available, otherwise path
    }
  },

  mounted () {
    console.log(this.$staticBaseUrl)
  },

  methods: {
    fullScreen () {
      if (!this.fullScreenEnabled) {
        this.$screenfull.request()
        this.fullScreenEnabled = true
      } else {
        this.$screenfull.exit()
        this.fullScreenEnabled = false
      }
    },

    updateCart (data) {
      this.$parent.show = false
      this.$emit('update-cart', { message: 'Successful' })
    },

    navigateBack: function () {
      if (typeof this.$route.params.UnitID !== 'undefined') {
        this.UnitID = this.$route.params.UnitID
      }

      if (typeof this.$route.params.VehicleReg !== 'undefined') {
        this.VehicleReg = this.$route.params.VehicleReg
      }

      if (typeof this.$route.params.previousPage !== 'undefined') {
        this.previousPage = this.$route.params.previousPage
      }

      if (typeof this.$route.params.dayDate !== 'undefined') {
        this.dayDate = this.$route.params.dayDate
      }

      if (typeof this.$route.params.VehicleID !== 'undefined') {
        this.VehicleID = this.$route.params.VehicleID
      }

      // const path = `/${this.previousPage}/${this.UnitID}/${this.VehicleReg}/${this.dayDate}`
      // this.$debug ? console.log(path) : null
      // this.$router.push(path)

      const viewNamesToMatch = [
        // 'Trip_List_Speed',

        'DayTripNav_SingleTrip',
        'Calendar_Trips_Select_v2',
        // 'DayTripNavigator',
        'OBD_Plot_Graph',
        'Calendar_Obd_Day_Select',
        'Calendar_Obd_Select',
        'Calendar_Obd_Select_Back'
      ]

      this.$debug ? console.log(' -> ' + this.currentViewName.toLowerCase()) : null

      if (viewNamesToMatch.some(name => this.currentViewName.toLowerCase().includes(name.toLowerCase()))) {
        //
        const path = `/${this.previousPage}/${this.UnitID}/${this.VehicleReg}/${this.dayDate}`
        this.$debug ? console.log(path) : null
        this.$router.push(path)
        //
      }
      else {
        if (this.$router !== null) {
          this.$router.go(-1)
        }
      }
    }

  }
}
</script>

<style></style>
